import { RootState } from '@store/index';
import { keyMap, pathToModuleCode, TModuleCode } from '@store/slices/app.slice';
// #region SALES DATE
export const selectPOSSalesDate = (state: RootState) => state.app.salesDate.pos;

export const selectBackOfficeSalesDate = (state: RootState) =>
  state.app.salesDate.posBackOffice;

export const selectFOSalesDate = (state: RootState) => state.app.salesDate.fo;

export const selectABKSalesDate = (state: RootState) => state.app.salesDate.abk;

const selectModuleCodeByPath = (path: string): TModuleCode | null => {
  return pathToModuleCode[path] ?? null;
};

export const selectSalesDateByPath = (
  state: RootState,
  path: string,
): string => {
  const moduleCode = selectModuleCodeByPath(path);
  if (!moduleCode) return '';

  return state.app.salesDate[keyMap[moduleCode]];
};

// export const selectPOSSalesDate = () =>
//   "";

// export const selectBackOfficeSalesDate = () =>
//  "";

// export const selectFOSalesDate = () =>
//  "";

// export const selectABKSalesDate = () =>
// "";

// const selectModuleCodeByPath = (path: string): TModuleCode | null => {
//   return pathToModuleCode[path] ?? null;
// };

// export const selectSalesDateByPath = (
//   state: RootState,
//   path: string,
// ): string => {
//   const moduleCode = selectModuleCodeByPath(path);
//   if (!moduleCode) return '';

//   return state.global.salesDate[keyMap[moduleCode]];
// };
// #endregion
